const projLibFund = () => import(/* webpackChunkName: "fund" */ './Fund');

export default {
  routes: [
    {
      path: '/projlib/fund',
      name: 'projLibFund',
      component: projLibFund
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/projLib/fund/router.js